import { createReducer, on } from '@ngrx/store';
import { ActionLogActions } from './action-log.actions';
import { initialState } from './action-log.state';

export const actionLogReducer = createReducer(
  initialState,

  on(ActionLogActions.public.updateActionLogFilter, (state, { filter }) => ({
    ...state,
    filter: filter,
  })),

  on(ActionLogActions.private.loadActionLogWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(
    ActionLogActions.private.loadActionLogSuccess,
    (state, { actionLogResponseDto }) => {
      const entities = { ...state.entities };
      actionLogResponseDto.entries.forEach((it) => {
        entities[it.eventId!!] = it;
      });

      return {
        ...state,
        entities: entities,
        pages: {
          ...state.pages,
          [state.filter!!.page!!]: actionLogResponseDto.entries.map(
            (it) => it.eventId!!,
          ),
        },
        totalCount: actionLogResponseDto.totalCount,
        isLoading: false,
        error: null,
      };
    },
  ),

  on(ActionLogActions.private.loadActionLogFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
  })),
);
